import { RouteRecordRaw } from 'vue-router';

import BaseLayout from '@/layouts/base-layout.vue';

const PersonalInformation = () => import(
  '@/modules/onboarding/pages/SoleTrader/PersonalData/PersonalInformation.vue'
);
const ResidentialAddress = () => import(
  '@/modules/onboarding/pages/SoleTrader/PersonalData/ResidentialAddress.vue'
);
const Turnover = () => import(
  '@/modules/onboarding/pages/SoleTrader/PersonalData/TurnoverPage.vue'
);
const FundsSource = () => import(
  '@/modules/onboarding/pages/SoleTrader/PersonalData/FundsSource.vue'
);
const VerifyPersonalData = () => import(
  '@/modules/onboarding/pages/SoleTrader/PersonalData/VerifyPage.vue'
);

const IdentityProof = () => import(
  '@/modules/onboarding/pages/SoleTrader/IdentityProof.vue'
);

const AddressProof = () => import(
  '@/modules/onboarding/pages/SoleTrader/AddressProof.vue'
);

const LiveScan = () => import(
  '@/modules/onboarding/pages/SoleTrader/LiveScan.vue'
);

const PricingPlan = () => import(
  '@/modules/onboarding/pages/SoleTrader/PricingPlan.vue'
);

const SoleTraderVerification = () => import(
  '@/modules/onboarding/pages/SoleTrader/VerificationPage.vue'
);

const STAGES = [
  'pages.onboarding.sole_trader.stages.personal_data',
  'pages.onboarding.sole_trader.stages.identity_proof',
  'pages.onboarding.sole_trader.stages.address_proof',
  'pages.onboarding.sole_trader.stages.liveness_check',
  'pages.onboarding.sole_trader.stages.plan',
];

const SOLE_TRADER_CHILDREN: RouteRecordRaw[] = [
  {
    path: 'data',
    name: 'onboarding-sole-trader-data',
    component: PersonalInformation,
    meta: {
      layout: {
        props: {
          stageIndex: 0,
        },
      },
    },
  },
  {
    path: 'address',
    name: 'onboarding-sole-trader-address',
    component: ResidentialAddress,
    meta: {
      layout: {
        props: {
          stageIndex: 0,
        },
      },
    },
  },
  {
    path: 'turnover',
    name: 'onboarding-sole-trader-turnover',
    component: Turnover,
    meta: {
      layout: {
        props: {
          stageIndex: 0,
        },
      },
    },
  },
  {
    path: 'funds-source',
    name: 'onboarding-sole-trader-funds-source',
    component: FundsSource,
    meta: {
      layout: {
        props: {
          stageIndex: 0,
        },
      },
    },
  },
  {
    path: 'verify-personal-data',
    name: 'onboarding-sole-trader-verify-personal-data',
    component: VerifyPersonalData,
    meta: {
      layout: {
        props: {
          stageIndex: 0,
        },
      },
    },
  },
  {
    path: 'proof-of-identity',
    name: 'onboarding-sole-trader-proof-of-identity',
    component: IdentityProof,
    meta: {
      layout: {
        props: {
          stageIndex: 1,
        },
      },
    },
  },
  {
    path: 'proof-of-address',
    name: 'onboarding-sole-trader-proof-of-address',
    component: AddressProof,
    meta: {
      layout: {
        props: {
          stageIndex: 2,
        },
      },
    },
  },
  {
    path: 'liveness-check',
    name: 'onboarding-sole-trader-liveness-check',
    component: LiveScan,
    meta: {
      layout: {
        props: {
          stageIndex: 3,
        },
      },
    },
  },
  {
    path: 'pricing',
    name: 'onboarding-sole-trader-pricing',
    component: PricingPlan,
    meta: {
      layout: {
        props: {
          stageIndex: 4,
        },
      },
    },
  },
  {
    path: 'verify',
    name: 'onboarding-sole-trader-verification',
    component: SoleTraderVerification,
    meta: {
      layout: {
        componentName: 'BaseLayoutWithLogout',
      },
    },
  },
];

export const SOLE_TRADER = {
  path: 'sole-trader',
  name: 'onboarding-sole-trader',
  children: SOLE_TRADER_CHILDREN,
  component: BaseLayout,
  props: {
    fetchProfile: false,
    baseLayoutConfig: {
      componentName: 'OnboardingSoleTraderLayout',
      props: {
        stages: STAGES,
      },
    },
  },
};
